import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import SEOHead from "../components/SEOHead";

function Resume() {
const navigate = useNavigate();
const auth = getAuth();

const handleStart = () => {
navigate("/get-started");
};

return (
<div style={{ padding: "40px", maxWidth: "1100px", margin: "0 auto" }}>
  
   <SEOHead
      title="Resume | Build a Better Resume Employers Want to See in 2026 | EmployPilot"
      description="Learn how to build a better resume employers want to see in 2026. Resume examples, formatting tips, resume skills, ATS guidance, and professional resume-building tools from EmployPilot."
      canonical="https://employpilot.com/resume"
    />

  <h1
    style={{
      fontSize: "48px",
      fontWeight: "bold",
      textAlign: "center",
      lineHeight: "1.15"
    }}
  >
    Build a Better Resume Employers Want to See in 2026
  </h1>

  <p
    style={{
      textAlign: "center",
      fontSize: "18px",
      color: "#555",
      marginTop: "20px",
      maxWidth: "850px",
      marginLeft: "auto",
      marginRight: "auto",
      lineHeight: "1.8"
    }}
  >
    The hiring process has changed. Employers and applicant tracking systems
    review resumes in seconds. A modern resume must be clear, structured,
    and designed to communicate value immediately. EmployPilot helps job
    seekers build stronger resumes that increase interview opportunities.
  </p>

  <div style={{ textAlign: "center" }}>
    <button onClick={handleStart} style={btnPrimary}>
      Build My Resume Free
    </button>
  </div>

  <section style={{ marginTop: "80px" }}>
    <h2>Why Your Resume Matters</h2>

    <p>
      Your resume is often the first impression an employer receives.
      Before interviews happen, before conversations begin, your resume
      determines whether you move forward or get filtered out.
    </p>

    <p>
      Strong resumes communicate experience clearly, highlight skills
      effectively, and make it easy for hiring managers to understand your
      value.
    </p>
  </section>

  <section style={{ marginTop: "60px" }}>
    <h2>What Makes a Good Resume in 2026?</h2>

    <ul>
      <li>Clear professional formatting</li>
      <li>Strong summary section</li>
      <li>Relevant work experience</li>
      <li>Keyword-optimized skills</li>
      <li>ATS-friendly structure</li>
      <li>Results-focused accomplishments</li>
      <li>Easy-to-read layout</li>
    </ul>
  </section>

  <section style={{ marginTop: "60px" }}>
    <h2>Resume Resources</h2>

    <p>
      Explore additional resume resources designed to help job seekers
      improve every section of their resume.
    </p>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
        gap: "16px",
        marginTop: "30px"
      }}
    >
      <Link to="/resume-builder">Resume Builder</Link>

      <Link to="/resume-examples">Resume Examples</Link>

      <Link to="/resume-skills">Resume Skills</Link>

      <Link to="/resume-summary-examples">
        Resume Summary Examples
      </Link>

      <Link to="/best-resume-format">
        Best Resume Format
      </Link>

      <Link to="/resume-mistakes">
        Resume Mistakes
      </Link>

      <Link to="/career-change-resume">
        Career Change Resume
      </Link>

      <Link to="/entry-level-resume-examples">
        Entry Level Resume Examples
      </Link>

      <Link to="/no-experience-resume">
        No Experience Resume
      </Link>

      <Link to="/ai-resume-builder">
        AI Resume Builder
      </Link>
    </div>
  </section>

  <section
    style={{
      marginTop: "80px",
      padding: "40px",
      backgroundColor: "#f8f9fa",
      borderRadius: "12px",
      textAlign: "center"
    }}
  >
    <h2>
      Ready To Build A Better Resume?
    </h2>

    <p
      style={{
        maxWidth: "700px",
        margin: "20px auto",
        color: "#666"
      }}
    >
      Create a professional resume, improve your interview opportunities,
      and start moving forward with confidence.
    </p>

    <button onClick={handleStart} style={btnPrimary}>
      Start My Resume Now — Free
    </button>
  </section>

  <div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>


);
}

const btnPrimary = {
backgroundColor: "#007bff",
color: "#fff",
padding: "14px 24px",
borderRadius: "8px",
border: "none",
cursor: "pointer",
marginTop: "20px",
fontWeight: "bold"
};

export default Resume;
